import { render, staticRenderFns } from "./Offhand.vue?vue&type=template&id=a1de97a8&scoped=true&"
import script from "./Offhand.vue?vue&type=script&lang=js&"
export * from "./Offhand.vue?vue&type=script&lang=js&"
import style0 from "./Offhand.vue?vue&type=style&index=0&id=a1de97a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1de97a8",
  null
  
)

export default component.exports